import styles from './OptionButtons.module.scss';
import type { IOptionType } from '../../pages/ProductDetail/ProductDetail';

interface IPropsType {
  title: string;
  options?: IOptionType[];
  selectedUid?: number;
  onSelect: (option: IOptionType) => void;
  emptyText?: string;
}

// 상품상세 옵션 선택(버튼형)
function OptionButtons(props: IPropsType) {
  return (
    <div className={styles.optionGroup}>
      <span className={styles.title}>
        {props.title}
        <span className={styles.required}>*</span>
      </span>
      {props.options && props.options.length > 0 ? (
        <div className={styles.buttons} role="radiogroup" aria-label={props.title}>
          {props.options.map((option) => (
            <button
              type="button"
              role="radio"
              aria-checked={option.po_uid === props.selectedUid}
              key={option.po_uid}
              className={option.po_uid === props.selectedUid ? styles.selected : ''}
              onClick={() => props.onSelect(option)}
            >
              <span>{option.po_poptionname}</span>
              {!!option.po_poptionprice && (
                <span className={styles.price}>
                  ${option.po_poptionprice.toLocaleString()}
                </span>
              )}
            </button>
          ))}
        </div>
      ) : (
        <span className={styles.empty}>{props.emptyText}</span>
      )}
    </div>
  );
}
export default OptionButtons;
